import { connect } from 'react-redux';
import Header from './Header';

const mapStateToProps = (state, props) => ({
  headerLogo: false
});

export default connect(mapStateToProps)(Header);
